import { ref } from '@vue/composition-api'
import { fetchLiveMatches } from '@ms/api/match'
import useCreateMatches from '@ms/components/match/useCreateMatches.js'
import { useRealSportsStore } from '@ms/stores/realsports.js'

export default function useHomeLive() {
  const { matches: liveMatches, resetMatches, setMatches } = useCreateMatches()
  const realsportStore = useRealSportsStore()

  // live matches 比赛数量
  const liveMatchesCount = ref(0)

  const resetLiveMatches = () => {
    resetMatches()
    liveMatchesCount.value = 0
  }

  // 设置 live matches list
  const setLiveMatches = ({ events = [], exceptEventIds = '' }) => {
    const list = exceptEventIds ? [...liveMatches.value, ...events] : events
    setMatches(list)
  }

  /**
   * 获取 Live 比赛列表
   * @param  {String} sportId sport id, 类似于 sr:sport:1
   * @return {[type]}         [description]
   */
  async function getLiveMatches({ sportId = '', exceptEventIds = '' }) {
    const { error, data } = await fetchLiveMatches(sportId, exceptEventIds)
    if (error) {
      return Promise.reject(error)
    }

    realsportStore.updateProductStatus(data.productStatus)
    if (!realsportStore.productDownOfLive) {
      setLiveMatches({ events: data.events, exceptEventIds })
      liveMatchesCount.value = data.count
    }
    return data
  }

  return {
    liveMatches,
    liveMatchesCount,
    resetLiveMatches,
    getLiveMatches
  }
}
